// Google Ads conversion — fires on successful form submissions across the site.
// Snippet source: Google Ads > Goals > Conversions > "Submit lead form" > Tag setup > Event snippet.
export const GOOGLE_ADS_CONVERSION_SEND_TO =
  "AW-18359612715/GachCKKB8tgcEKvqxbJE";

/**
 * Fire the "Submit lead form" conversion event.
 * @param {string} source - label describing which form (e.g. "family-day", "visit", "prayer").
 */
export function fireGoogleAdsConversion(source = "form_submit") {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "conversion", {
      send_to: GOOGLE_ADS_CONVERSION_SEND_TO,
      value: 1.0,
      currency: "USD",
      event_category: "form_submission",
      event_label: source,
    });
  } catch (_) {
    /* silent */
  }
}
